import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import API from 'config/ApiConfig';

export default function DetailPresensi() {
  const [presensiData, setPresensiData] = useState(null);
  const [tentorData, setTentorData] = useState(null);
  const [siswaData, setSiswaData] = useState(null);
  const [fetchError, setFetchError] = useState(null);
  const { presensiId } = useParams(); // Ambil presensiId dari useParams
   // const API_BASE_URL = 'http://localhost:5000/api/admin';
   const API_BASE_URL = API.API_ADMIN
  const JWT_TOKEN = localStorage.getItem('authToken');

  function getAuthHeaders() {
    return {
      'Authorization': `Bearer ${JWT_TOKEN}`,
      'Content-Type': 'application/json',
    };
  }

  useEffect(() => {
    const fetchTentor = async (tentorId) => {
      try {
        const response = await fetch(`${API_BASE_URL}/tentor/${tentorId}`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setTentorData(data);
      } catch (error) {
        console.error('Error fetching tentor details:', error);
        setFetchError('Failed to fetch tentor details.');
      }
    };

    const fetchSiswa = async (siswaId) => {
      try {
        const response = await fetch(`${API_BASE_URL}/siswa/${siswaId}`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setSiswaData(data);
      } catch (error) {
        console.error('Error fetching siswa details:', error);
        setFetchError('Failed to fetch siswa details.');
      }
    };

    const fetchPresensi = async () => {
      if (!presensiId) return; // Tambahkan pengecekan jika presensiId tidak ada

      try {
        const response = await fetch(`${API_BASE_URL}/rekap/${presensiId}`, {
          headers: getAuthHeaders(),
        });
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setPresensiData(data);

        if (data.tentor_id) {
          fetchTentor(data.tentor_id); // Ambil data tentor jika tentor_id ada
        }

        if (data.siswa_id) {
          fetchSiswa(data.siswa_id); // Ambil data siswa jika siswa_id ada
        }
      } catch (error) {
        console.error('Error fetching presensi details:', error);
        setFetchError('Failed to fetch presensi details.');
      }
    };

    fetchPresensi();
  }, [presensiId]);

  if (fetchError) {
    return <p className="text-red-500 text-xs">{fetchError}</p>;
  }

  if (!presensiData) {
    return <p>Loading...</p>;
  }

  return (
    <div>
      <h3 className="font-bold uppercase text-lg text-blueGray-700 align-center m-4">Detail Presensi</h3>
      <div className="space-y-4 mb-2">
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Nama Siswa:</p>
          <p className="text-blueGray-600">{siswaData ? siswaData.nama : 'Belum Ada'}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Nama Tentor:</p>
          <p className="text-blueGray-600">{tentorData ? tentorData.nama : 'Belum Ada'}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Harga:</p>
          <p className="text-blueGray-600">{presensiData.harga ? `Rp ${presensiData.harga}` : 'Belum Ada'}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-red-500">Pendapatan Bersih:</p>
          <p className="text-blueGray-600">{presensiData.pendapatan ? `Rp ${presensiData.pendapatan}` : 'Belum Ada'}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Mata Pelajaran:</p>
          <p className="text-blueGray-600">{presensiData.mata_pelajaran || 'Belum Ada'}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Waktu Pembelajaran:</p>
          <p className="text-blueGray-600">{presensiData.waktu_pembelajaran ? presensiData.waktu_pembelajaran : 'Belum Ada'}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Jam:</p>
          <p className="text-blueGray-600">{presensiData.jam || 'Belum Ada'}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Durasi:</p>
          <p className="text-blueGray-600">{presensiData.durasi || 'Belum Ada'}</p>
        </div>
        <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Catatan Belajar Siswa:</p>
          <p className="text-blueGray-600">{presensiData.feedback || 'Belum Ada'}</p>
        </div>
        {/* <div className="bg-white p-4 rounded shadow border border-blueGray-300 mb-2">
          <p className="font-semibold text-blueGray-600">Ulasan:</p>
          <p className="text-blueGray-600">{presensiData.ulasan || 'Belum Ada'}</p>
        </div> */}
        <div>
          <a href="/admin/presensi">
            <button
              type="button"
              className="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none m-4 ease-linear transition-all duration-150"
            >
              Kembali
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}
